import { render, staticRenderFns } from "./ViewJobWithCandidates.vue?vue&type=template&id=00f39b8b&scoped=true&"
import script from "./ViewJobWithCandidates.vue?vue&type=script&lang=ts&"
export * from "./ViewJobWithCandidates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f39b8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
